// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result pre{margin:0;padding:0}.cm-attr{color:#190}.cm-input-value,.cm-value,.cm-variable,.row-id{color:#e60}.cm-log{color:#a200b5}.cm-query{color:#019}", ""]);
// Exports
module.exports = exports;
